import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
//import template = require('dojo/text!./AddressFinderHome.html');
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _KanbanHubBase from '../../moreCore/UI/Kanban/_KanbanHubBase';
import { KanbanTypes } from "../../moreCore/UI/Kanban/KanbanTypes";
import { EntityHelpers } from "../../more/Helpers";
import { AddressClassnames } from "../AddressWizard/AddressWizardTypes";
import Edit from '../../moreCore/UI/Edit/Edit';
import { GenericDialogTypes } from "../../moreCore/UI/GenericDialog/GenericDialogTypes";

/**
 * 
 */
/**
 * 
 */

interface EditorData {
    note: string
}
class AddressCategoriesKanbanHub extends compose(_KanbanHubBase<EditorData>) {
    //templateString = template; // nur falls nötig ein eigenes laden!

  


    private _onClick_Element(data: KanbanTypes.DataElement<EditorData>) {
        //alert(data.sourceItemID);
        EntityHelpers.openEntityView({
            entityClass: AddressClassnames.vt_addresses,
            entityId: data.sourceItemID,
            label: data.label,
            contextName: "addressCategoriesKanban"
        });
    }
    private _onEdit_Element(data: KanbanTypes.DataElement<EditorData>) {
        let input = new Edit();
        let value = data.changedData?.note;

        input.setLabel("General_Label_Note");
        input.setValue(data.secondaryLabel);

        
        let dlg = new GenericDialog();
        dlg.setup({
            header: data.label,
            content: input,
            callback: lang.hitch(this, this._onSubmitEdit, data, input),
            buttonPreset: "okcancel"
        });
        dlg.disableButton("ok");

        input.on("change", lang.hitch(dlg, "enableButton", "ok"));
    }

    private _onSubmitEdit(data: KanbanTypes.DataElement, input: MdsLax<InstanceType<typeof Edit>>, result: GenericDialogTypes.GenericDialogResult) {
        
        if (result == GenericDialogTypes.GenericDialogResult.ok) {
            this.setElementData(data, { note: input.getValue() });
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.setup({
            filterpanelAPI: "Webtool_API_AddressCategoriesKanban__GetFilterPanel",
            kanbanConfigAPI: "Webtool_API_AddressCategoriesKanban__GetKanbanConfig",
            changeSaveAPI: "Webtool_API_AddressCategoriesKanban__SaveChanges",
            elementDetailsClick: lang.hitch(this, this._onClick_Element),
            elementEditClick: lang.hitch(this, this._onEdit_Element),
            infoContentAPI: "Webtool_API_AddressCategoriesKanban__GetInfoContent"
        });

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setTitles("AddressCategoriesKanban_MainTitle");

    }
}

export default mdsWidget(AddressCategoriesKanbanHub);
